import { Component } from '@angular/core';

@Component({
  selector: 'resources-page',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.less']
})
export class ResourcesPageComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/pages/resources/resources.component.ts